import React from 'react';
import { FormInput } from './FormInput';

const FormDatePicker = ({
    label,
    name,
    value,
    onChange,
    onBlur,
    error,
    required = false,
    disabled = false,
    placeholder,
    className = '',
    style = {},
    min,
    max,
    ...props
}) => {
    return (
        <FormInput
            label={label}
            type="date"
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            error={error}
            required={required}
            disabled={disabled}
            placeholder={placeholder}
            className={className}
            style={style}
            min={min}
            max={max}
            {...props}
        />
    );
};

export { FormDatePicker };
export default FormDatePicker;
